import { Button, Input } from "antd";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router";
import "../../index.css";
import "./Auth.css";
import CryptoJS from "crypto-js";

import apiService from "../../services/apiService";
import { toast } from "react-toastify";
import { useState } from "react";

type FormValues = {
  otp: string;
};

const VerifyEmail = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: "onBlur", // Validation triggered on blur
  });

  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const [isCooldown, setIsCooldown] = useState(false);
  const [timer, setTimer] = useState(30);

  const onSubmit = async (data: FormValues) => {
    try {
      // Encrypt OTP before sending
      const encryptedOtp = CryptoJS.SHA256(data.otp).toString();

      const response: {
        token: string;
        message: string;
      } = await apiService.post("/auth/verify-otp", {
        email: email,
        otp: encryptedOtp,
      });
      if (response) {
        toast.success(response.message);
        navigate("/reset-password");
      }
    } catch (error) {
      toast.error(error.message ? error.message : error);
    }
  };

  const resendCode = async () => {
    if (isCooldown) return;
    try {
      const response: {
        token: string;
        message: string;
      } = await apiService.post("/auth/forgot-password", { email: email });
      if (response) {
        toast.success("OTP Resend Successfully");
        navigate("/verify-email");
        setIsCooldown(true);
        let timeLeft = 30;
        setTimer(timeLeft);

        const interval = setInterval(() => {
          timeLeft -= 1;
          setTimer(timeLeft);

          if (timeLeft === 0) {
            clearInterval(interval);
            setIsCooldown(false);
          }
        }, 1000);
      }
    } catch (error) {
      toast.error(error.message ? error.message : error);
    }
  };

  return (
    <>
      <div className="login-container container">
        <div className="verification-form">
          <div className="form-header login-header">Verify your email</div>
          <p className="form-paragraph">
            We've sent you a confirmation code on your email, <b>{email}</b>{" "}
            please check your inbox.
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* <div style={{ paddingTop: "30px" }}>
                            <div className="form-label login-label">Email</div>
                            <Input size="large" style={{ height: "48px", borderRadius: "4px" }} />
                        </div> */}
            <div style={{ paddingTop: "30px" }}>
              <div className="form-label login-label">
                Enter 6-digit confirmation code
              </div>
              {/*                           <Controller
                                name="email"
                                control={control}
                                rules={{
                                    required: "Please enter your email!",
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Please enter a valid email!",
                                    },
                                }}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        size="large"
                                        className={errors.email ? "ant-input-status-error" : ""}
                                        style={{ height: "48px", borderRadius: "4px" }}
                                    />
                                )}
                            />
                            {errors.email && (
                                <div className="ant-form-item-explain-error">{errors.email.message}</div>
                            )} */}
            </div>
            {/*  <div style={{ paddingTop: "30px" }}>
                            <div className="form-label login-label">Password</div>
                            <Input.Password size="large" style={{ height: "48px", borderRadius: "4px" }} />
                        </div> */}

            <Controller
              name="otp"
              control={control}
              rules={{
                required: "OTP is required",
                minLength: { value: 6, message: "OTP must be 6 digits" },
                maxLength: { value: 6, message: "OTP must be 6 digits" },
                pattern: { value: /^\d{6}$/, message: "Invalid OTP format" },
              }}
              render={({ field }) => <Input.OTP size="large" {...field} />}
            />
            {errors.otp && (
              <div className="ant-form-item-explain-error">
                {errors.otp.message}
              </div>
            )}

            <div style={{ width: "100%" }}></div>

            <div
              style={{ paddingTop: "20px" }}
              className="forgot-password-label"
            >
              <span style={{ color: "#000000" }}>Didn't received?</span>{" "}
              <Link
                to="/verify-email"
                className="forgot-password-label"
                style={{ color: isCooldown ? "gray" : "" }}
                onClick={() => resendCode()}
              >
                Resent code
              </Link>
            </div>
            {isCooldown && (
              <div style={{ color: "red" }}>
                You can resent code in {timer} second
              </div>
            )}
            <div style={{ paddingTop: "30px" }}>
              <Button
                color="primary"
                variant="solid"
                size="large"
                className="form-button"
                htmlType="submit"
              >
                Continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
